import * as React from 'react';
import styled from 'styled-components';
import { WorkListCard } from './HomePage';
import WorkInfoCard from '../components/common/WorkInfoCard';
import { projects } from '../api/project';

const HeaderSection = styled.div`
  max-width: 510px;
  margin: auto;
  margin-top: 50px;
  text-align: center;
  h1 {
    font-size: 48px;
    color: ${({ theme }) => theme.palette.text.primary};
    @media (max-width: 768px) {
      font-size: 30px;
    }
  }
  p {
    margin-top: 24px;
    color: ${({ theme }) => theme.palette.text.secondary};
    font-size: 16px;
  }
`;

const FilterTag = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 37px;
  margin-bottom: 60px;
  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
`;
const Tag = styled.p`
  margin-right: 16px;
  padding: 7px 21px 5px;
  border-radius: 13px;
  font-size: 14px;
  background-color: ${({ theme }) => theme.palette.background.whiteBg100};
  color: ${({ theme }) => theme.palette.primary.main};
  @media (max-width: 768px) {
    margin-bottom: 15px;
  }
`;

function WorkPage() {
  return (
    <>
      <HeaderSection>
        <h1>Creating Unique Digital Experiences.</h1>
        <p>
          I’m passionate about building quality products that people enjoy, and solving real-world
          problems. Love learning and sharing content to give back to the community.
        </p>
      </HeaderSection>
      <FilterTag>
        <Tag>UI UX Design</Tag>
        <Tag>Blockchain</Tag>
        <Tag>Web Development</Tag>
        <Tag>Javascript</Tag>
      </FilterTag>
      <WorkListCard>
        {projects.map((item) => (
          <WorkInfoCard id={item.id} {...item} />
        ))}
      </WorkListCard>
    </>
  );
}

export default WorkPage;
